import { Pie } from '@ant-design/plots';
import { Table, Button } from 'antd';
import { PartitionOutlined } from '@ant-design/icons';
 import utils from '../Common/utils';
import MoneyDisplay from '../Common/MoneyDisplay';
import ColorSquare from '../Common/ColorSquare';
import ShowIntentsBtn from '../Common/ShowIntentsBtn';
import { Link } from 'react-router-dom';

const COLORS = [
    '#D22C2C', '#D26E2C', '#D2B12C', '#B1D22C', '#6ED22C',
    '#2CD22C', '#2CD26E', '#2CD2B1', '#2CB1D2', '#2C6ED2',
    '#2C2CD2', '#6E2CD2', '#B12CD2', '#D22CB1', '#D22C6E',
    '#D88C8C', '#D8AA8C', '#D8C98C', '#C9D88C', '#AAD88C',
    '#8CD88C', '#8CD8AA', '#8CD8C9', '#8CC9D8', '#8CAAD8',
    '#8C8CD8', '#AA8CD8', '#C98CD8', '#D88CC9', '#D88CAA',
]


const BasePieChartWithTable = ({ data: rawData = [], ...props }) => {

  const data = rawData.map((x, idx) => ({
    ...x,
    color: COLORS[idx % COLORS.length], // modulo if you have fewer COLORS than data items
  }));

  const amountSum = data.reduce((acc, item) => acc + item.amount, 0);


  const tableCols = [
      {
          title: 'Barva',
          dataIndex: 'color',
          key: 'color',
          render: color => <ColorSquare color={color} />
      },
      {
          title: '%',
          dataIndex: 'percentage',
          key: 'percentage',
          render: x => <b>{x} %</b>
      },
      {
          title: props.aggColTitle,
          dataIndex: 'title',
          key: 'title',
      },
      {
          title: 'Znesek',
          dataIndex: 'amount',
          key: 'amount',
          render: x => <MoneyDisplay type={props.moneyType} val={x} />
      },
      {
          title: 'Prikaži transakcije',
          key: 'show_intents',
          align: 'center',
          // NOTE: deliberately not `dataIndex: 'id'`. The N/A bucket's id is null,
          // which URLSearchParams stringifies to "" -- the filter then looks empty
          // and gets stripped, silently showing ALL transactions. The backend hands
          // us `filter_value` (the id, or the "no value" sentinel) instead.
          render: (_, record) => {
            const val = record.filter_value ?? record.id ?? utils.NO_VALUE;
            return (
              <Link to={{pathname: "/intents", hash: utils.getUpdatedURL({[props.filterName]: [val]})}}>
                <ShowIntentsBtn/>
              </Link>
            );
          }
      },
  ];

  if (props.onDrillDown) {
    tableCols.splice(tableCols.length - 1, 0, {
      title: 'Razčleni',
      key: 'drill',
      align: 'center',
      render: (_, record) => record.has_children
        ? <Button size="small" icon={<PartitionOutlined />} onClick={() => props.onDrillDown(record)} />
        : null
    });
  }

  const config = {
    data: data,
    angleField: 'percentage',
    innerRadius: 0.6,
    colorField: 'color',
    color: x => x.color,

    label: {
      type: 'inner',
      formatter: x => `${x.percentage} %`,
      style: {
        fontWeight: 'bold',
      },
      offset: 0,
    },
    legend: false,
    tooltip: false,
        statistic: {
      // Top line (usually "Total" or some label)
      title: {
        formatter: () => 'Skupaj',
        style: {
          fontSize: '14px',
          lineHeight: 1,
          fill: '#999',
        },
      },
      // Bottom line (your calculated value)
      content: {
        formatter: () => utils.formatToMoney(amountSum, true),
        style: {
          fontSize: '24px',
          fontWeight: 'bold',
          fill: '#262626',
        },
      },
    }
  };
  return (
    <>
      {props.headerExtra}
      <Pie {...config} />
      <Table loading={props.loading} dataSource={data} columns={tableCols} size="small" />
    </>
  )
};
export default BasePieChartWithTable;
